import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export function useMcpAuthorizeGrant(params: {
  client_id?: string;
  response_type?: string;
  redirect_uri?: string;
  state?: string;
  code_challenge?: string;
  code_challenge_method?: string;
}) {
  return useMutation({
    mutationFn: async (allow: boolean) => {
      const data = await apiClient.postMcpAuthorizeGrant({ allow }, { queries: params });
      return data;
    },
    onSuccess: (data) => {
      window.location.href = data.redirect_uri;
    },
  });
}
